import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { AustraliaAdmissionDayPage } from "@modules/study/webinar/australia_admission_day";

const AustraliaAdmissionDay = () => {
  return (
    <LayoutMain
      title={`Australia Admission Day`}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/australia-admission-day`}
    >
      <AustraliaAdmissionDayPage />
    </LayoutMain>
  );
};

export default AustraliaAdmissionDay;
